// Renders author-supplied rich-text HTML, sanitized. Use everywhere a value
// produced by RichTextEditor is displayed to readers.
import DOMPurify from 'dompurify';

const CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'a', 'ul', 'ol', 'li', 'h2', 'h3', 'blockquote', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

export default function RichText({ html, className, style }) {
  const clean = DOMPurify.sanitize(html || '', CONFIG);
  return <div className={`richtext${className ? ' ' + className : ''}`} style={style} dangerouslySetInnerHTML={{ __html: clean }} />;
}
